import { defineMessages } from 'react-intl'


export default defineMessages({
  preferences: {
    defaultMessage: 'Preferences',
    id: 'preferences-button.preferences',
  },
})
